import template from './calendarInlineHide.html';
import './calendarInlineHide.scss';

let calendarInlineHideComponent = {
  restrict: 'E',
  bindings: {
    isHide: '<',
    clicked: '&'
  },
  template
};

export default calendarInlineHideComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHide/calendarInlineHide.component.js